
import { defineComponent } from 'vue'
import { format } from 'date-fns'
import timeService from '../common/timeService'
import AppointmentTypeService from '../common/appointmentTypeService'
import AppointmentTypeOffering from '../models/appointmentTypeOffering'
import { AppointmentType, AppointmentTypeDetail } from '../models/appointmentType'
import IntakeFormEditor from '../components/IntakeFormEditor.vue'
import AppointmentTypeForm from '../components/AppointmentTypeForm.vue'
import Quill from '../common/quill'
// import Quill from 'quill/core'

export default defineComponent({
  name: 'AppointmentType',

  data () {
    return {
      /** The AppointmentType to view and edit */
      appointmentType: null as unknown as AppointmentTypeDetail,

      /** New offering time */
      editedtime: '',

      /** Form containing edited general informaiton */
      editForm: null as unknown as AppointmentType,

      /** The Appointment type's confirmation message */
      confirmationMessage: '',

      quill: null as any,

      /** Indicator for showing confirmation message form */
      shouldShowConfirmationMessageForm: false,

      /** Indicator to show form for general info */
      shouldShowEditForm: false,

      /** Indicator to show the intake form editor */
      shouldShowIntakeFormEditor: false,

      /** Indicator to show offering form */
      shouldShowTimeForm: false
    }
  },

  watch: {
    $route: {
      handler (route) {
        AppointmentTypeService.get(route.params.id).then(res => {
          this.appointmentType = res.data
        })
      },
      immediate: true
    },

    /** Indicate if should show Confirmation Message Form */
    shouldShowConfirmationMessageForm (val) {
      if (val) {
        setTimeout(() => {
          this.quill = new Quill('#editor', {
            modules: {
              toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link']
              ]
            },
            theme: 'snow'
          }) as Quill

          this.quill.root.innerHTML = this.appointmentType.emailConfirmationMessage
        }, 0)
      }
    }
  },

  computed: {
    /** Determines if the new time is valid */
    isValidTime (): boolean {
      return timeService.isValidTimeString(this.editedtime)
    }
  },

  methods: {
    /**
     * Adds a new offering
     */
    addOffering () {
      const time = timeService.convertTimeFromString(this.editedtime)
      if (time == null) {
        return
      }

      AppointmentTypeService.createOffering(this.appointmentType.id, time).then(res => {
        this.appointmentType.offerings.push(res.data)
        this.editedtime = ''
        this.shouldShowTimeForm = false
      })
    },

    /**
     * Updates the appointment types's general info
     */
    handleAppointmentTypeUpdate (appointmentType: AppointmentType) {
      Object.assign(this.appointmentType, appointmentType)
      this.shouldShowEditForm = false
    },

    /**
     * Formats a date time as a string
     */
    format (date: Date): string {
      return format(date, 'MMM do hh:mma (zzz)')
    },

    /**
     * Formats a time represented as a number as a string
     * @param timeNum: The time represented as the number of minutes since the start of day
     */
    formatOffering (timeNum: number): string | null {
      return timeService.convertTimeToString(timeNum)
    },

    formatDuration (timeNum: number): string {
      return timeService.convertDurationToString(timeNum)
    },

    /**
     * Removes the given offering
     * @param: The offering
     */
    removeOffering (offering: AppointmentTypeOffering) {
      if (window.confirm('Are you sure?')) {
        AppointmentTypeService.removeOffering(offering.id).then(() => {
          const ind = this.appointmentType.offerings.findIndex(at => at.id === offering.id)
          this.appointmentType.offerings.splice(ind, 1)
        })
      }
    },

    /**
     * save confirmation message
     */
    saveConfirmationMessage () {
      const message = this.quill.root.innerHTML
      AppointmentTypeService.updateConfirmationMessage(this.appointmentType.id, message).then(res => {
        this.appointmentType.emailConfirmationMessage = message
        this.shouldShowConfirmationMessageForm = false
      })
    },

    /**
     * Updates the intake form
     * @param newForm: The updated intake form
     */
    updateIntakeForm (newForm) {
      this.appointmentType.currentForm = newForm
      this.shouldShowIntakeFormEditor = false
    }
  },

  components: {
    IntakeFormEditor,
    AppointmentTypeForm
  }
})
